export const SITE_URL = "https://peerstack.tech";
export const META_IMAGE = `${SITE_URL}/images/meta-logo.png`;
